module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "document-invitations"
    }
  }, [_c('document-set-header', {
    attrs: {
      "document-set": _vm.store.data.currentDocumentSet
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Account Access")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "invitations-block col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.invitations), function(invitation) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-7"
    }, [_vm._v("\n                    " + _vm._s(invitation.user.firstName) + " " + _vm._s(invitation.user.lastName) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_vm._v("\n                    " + _vm._s(invitation.shareStatus) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 action"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          return _vm.revoke(invitation)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "recipients-block col-xs-12"
  }, [_c('h3', [_vm._v("Invite:")]), _vm._v(" "), _vm._l((_vm.recipients), function(recipient) {
    return _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "recipient col-xs-12"
    }, [_c('div', {
      staticClass: "fields"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.userFirstName),
        expression: "recipient.userFirstName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "first name"
      },
      domProps: {
        "value": (recipient.userFirstName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "userFirstName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.userLastName),
        expression: "recipient.userLastName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "last name"
      },
      domProps: {
        "value": (recipient.userLastName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "userLastName", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (recipient.userEmail),
        expression: "recipient.userEmail"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "email",
        "placeholder": "email"
      },
      domProps: {
        "value": (recipient.userEmail)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(recipient, "userEmail", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xs action removeRecipient",
      on: {
        "click": function($event) {
          return _vm.removeRecipient(recipient)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary",
    on: {
      "click": _vm.addRecipient
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(" Add recipient")]), _vm._v(" "), (_vm.recipients.length) ? _c('button', {
    staticClass: "btn btn-md btn-success",
    on: {
      "click": _vm.invite
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Send")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": {
        name: 'DocumentsView'
      }
    }
  }, [_vm._v("Done")])], 1)], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header clearfix"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e2f41b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentsInvitations.vue
// module id = 277
// module chunks = 1